import React from 'react';
import { Modal, Spin, Typography } from 'antd';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import {
  registrationStateTypes,
  useRegistrationControllers,
  useRegistrationSubscribe,
} from '../../../../services/acceptanceRegistration';
import RegistrationAddressDescription from '../../ui/RegistrationAddressDescription';
import SelectOwner from './SelectOwner';
import FetchError from '../../../../../../components/FetchError';
import IndividualDatesAlert from './IndividualDatesAlert';
import styles from './index.module.scss';

const SelectOwnerForRegistrationModal = () => {
  const { isOpen } = useModalWatch({
    name: modalNames.selectOwnerForRegistration,
  });

  const room = useRegistrationSubscribe({
    type: registrationStateTypes.address,
    selector: (payload) => payload.value,
  });

  const availabilityState = useRegistrationSubscribe({
    type: registrationStateTypes.registerAvailability,
  });

  const hasOwner = useRegistrationSubscribe({
    type: registrationStateTypes.selectedOwner,
    selector: (payload) => Boolean(payload.value),
  });

  const { selectOwnerModalHandlers } = useRegistrationControllers();

  return (
    <Modal
      {...selectOwnerModalHandlers}
      centered
      title="Выбор собственника"
      visible={isOpen}
      maskClosable={false}
      okText="Выбрать интервал"
      okButtonProps={{ disabled: !hasOwner }}
      destroyOnClose
    >
      <Spin spinning={availabilityState.status === 'loading'}>
        {availabilityState.status === 'error' && (
          <FetchError
            text={availabilityState.message}
            refetch={availabilityState.refetch}
          />
        )}

        {availabilityState.status === 'notAvailable' && (
          <Typography.Text type="danger">
            {availabilityState.message}
          </Typography.Text>
        )}

        {Boolean(room) && (
          <div className={styles.body}>
            {Boolean(room) && (
              <>
                <IndividualDatesAlert
                  startDate={room.individualStartDate}
                  endDate={room.individualEndDate}
                />
                <RegistrationAddressDescription room={room} />
                <SelectOwner />
              </>
            )}
          </div>
        )}
      </Spin>
    </Modal>
  );
};

export default SelectOwnerForRegistrationModal;
